import React from 'react';
import PropTypes from 'prop-types';
import { VenueCardGrid, Link } from '@resy/ui-kitchen';
import MultiStepListModal from '../../../../../../ui-kitchen/src/components/MultiStepListModal';
import './AmexGDAVenues.scss';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';

const MAX_CARDS = 4;
class AmexGDAVenues extends React.Component {
    static propTypes = {
      $rootScope: PropTypes.shape({
        $digest: PropTypes.func.isRequired,
      }).isRequired,
      isUserLoggedInAsGDA: PropTypes.bool,
      locationSlug: PropTypes.string.isRequired,
      selectedDate: PropTypes.string.isRequired,
      selectedSeats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      loadNotifyModal: PropTypes.func.isRequired,
      showSeeMore: PropTypes.bool,
      collection: PropTypes.shape().isRequired,
      restaurants: PropTypes.arrayOf(PropTypes.shape({
        venue: PropTypes.shape({
          priceRange: PropTypes.number,
          rating: PropTypes.number,
          name: PropTypes.string,
          images: PropTypes.arrayOf(PropTypes.string),
          collections: PropTypes.arrayOf(PropTypes.shape({})),
        }).isRequired,
      })),
      Analytics: PropTypes.shape({
        event: PropTypes.func,
      }).isRequired,
      headline: PropTypes.string.isRequired,
      intro: PropTypes.string.isRequired,
      utm: PropTypes.string.isRequired,
      printContent: PropTypes.func.isRequired,
      cityName: PropTypes.string.isRequired,
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        xl: PropTypes.bool,
      }).isRequired,
      taggingConfig: PropTypes.shape({
        event_name: PropTypes.string.isRequired,
        gda_book_now: PropTypes.shape({
          item_name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    };

    static defaultProps = {
      restaurants: undefined,
      showSeeMore: true,
      isUserLoggedInAsGDA: false,
    }

  /**
   * The requirement is that only Resy Select badges will be displayed,
   * so filter out the rest
   */
  filterOutNonSelectBadges = (results) => {
    const RESY_SELECT = 6;
    if (!results) return undefined;

    return results.map((result) => {
      const resySelect = result.venue.collections?.filter((collection) => collection.type_id === RESY_SELECT);
      const newItem = {
        ...result,
        venue: {
          ...result.venue,
          collections: resySelect,
        },
      };
      return newItem;
    });
  };

  handleSeeMoreClick = () => {
    const { Analytics: { event } } = this.props;

    handleMktAnalytics(event, CTA_EVENT_NAME, {
      action_name: 'GDA Book Now - See More Click',
    });
  };

  getSeeMoreParams = () => {
    const { collection, utm } = this.props;

    const {
      id: collectionId,
    } = collection;

    const {
      selectedDate,
      selectedSeats,
    } = this.props;

    const params = {
      seats: selectedSeats,
      date: selectedDate,
      ...(utm || {}),
    };

    if (collectionId) {
      params.list = `collection_${collectionId}`;
    }

    return params;
  };

  renderShowMoreButton = () => {
    const {
      collection,
      restaurants,
      locationSlug,
      showSeeMore,
    } = this.props;

    const {
      info: {
        name,
      },
    } = collection;

    const link = `/cities/${locationSlug}/search`;
    const query = this.getSeeMoreParams();

    return ((restaurants?.length > MAX_CARDS) && showSeeMore) ? (
      <p>
        <Link
          className="GDA__Venues--CTA"
          href={{ pathname: link, query }}
          onContextMenu={() => this.handleSeeMoreClick()}
          onClick={() => this.handleSeeMoreClick()}
          aria-label={`See more venues in the ${name} collection`}
          target="_self"
        >
          see more
        </Link>
      </p>
    ) : null;
  };

  render() {
    const {
      restaurants,
      $rootScope,
      isUserLoggedInAsGDA,
      loadNotifyModal,
      selectedDate,
      selectedSeats,
      headline,
      intro,
      Analytics,
      printContent,
      cityName,
      matchMedia,
      locationSlug,
    } = this.props;
    const isMobile = !matchMedia.md;
    const restaurantListLength = restaurants ? this.filterOutNonSelectBadges(restaurants).length : 0;

    const link = `/cities/${locationSlug}/search`;
    const query = this.getSeeMoreParams();

    return (
      <div className="GDA__Venues">
        <h2>{`${printContent(headline, 'headline', true)} ${cityName}`}</h2>
        <p className="GDA__Venues__blurb">{printContent(intro, 'intro', true)}</p>

        <div className={`VenueList__body card-${restaurantListLength}-list`}>
          <VenueCardGrid
            $rootScope={$rootScope}
            userIsGda={isUserLoggedInAsGDA}
            event={Analytics.event}
            list="Amex Global dining access"
            loadNotifyModal={loadNotifyModal}
            restaurants={this.filterOutNonSelectBadges(restaurants)}
            selectedDate={selectedDate}
            selectedSeats={selectedSeats}
            isGda
            matchMedia={matchMedia}
            isMobile={isMobile}
            showCarouselButtons={restaurantListLength > MAX_CARDS}
            link={{ pathname: link, query }}
            handleSeeMoreClick={this.handleSeeMoreClick}
            isAmexGDA
          />
          <MultiStepListModal Analytics={Analytics} />
        </div>
        {this.renderShowMoreButton()}
      </div>
    );
  }
}

AmexGDAVenues.propTypes = {
};

export default AmexGDAVenues;
